module.exports = __webpack_public_path__ + "c6b8d2d7718023a5e596426594ff8ddf.jpg";